(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old-2025"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-redesign"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"])`).forEach((element) => {
        element.classList.remove('active');
      })
      const activeMedia = this.querySelector(`[data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
    }
  }

  customElements.define('product-modal', ProductModal);

  // Global video visibility monitoring
  document.addEventListener('DOMContentLoaded', function() {
    console.log('🚀 Initializing global video visibility monitoring...');
    
    // Get all deferred media elements on the page
    const deferredMediaElements = document.querySelectorAll('deferred-media');
    console.log(`🔍 Found ${deferredMediaElements.length} deferred media elements on page load`);
    

    
    // Function to check if modal is open
    function isModalOpen() {
      const modal = document.querySelector('.product-media-modal');
      return modal && modal.hasAttribute('open');
    }
    
    // Function to check if element is visible in modal viewport
    function isElementVisibleInModal(element) {
      const modal = document.querySelector('.product-media-modal');
      if (!modal || !isModalOpen()) return false;
      
      const modalContent = modal.querySelector('.product-media-modal__content');
      if (!modalContent) return false;
      
      const elementRect = element.getBoundingClientRect();
      const modalRect = modalContent.getBoundingClientRect();
      
      // Check if element is visible within the modal viewport
      return (
        elementRect.top >= modalRect.top &&
        elementRect.left >= modalRect.left &&
        elementRect.bottom <= modalRect.bottom &&
        elementRect.right <= modalRect.right
      );
    }
    
         // Function to check video visibility
     function checkVideoVisibility() {
       if (!isModalOpen()) {
         return; // Only check when modal is open
       }
       
       console.log('🎯 Modal is open, checking deferred media visibility...');
       
       deferredMediaElements.forEach((deferredMedia, index) => {
         const isVisible = isElementVisibleInModal(deferredMedia);
         const hasVideo = deferredMedia.querySelector('video, .js-youtube, .js-vimeo');
         const hasPoster = deferredMedia.querySelector('.deferred-media__poster');
         const mediaId = deferredMedia.closest('[data-media-id]')?.getAttribute('data-media-id') || 'unknown';
         
         console.log(`🎥 Deferred media ${index + 1} (Media ID: ${mediaId}):`);
         console.log(`   - Is visible in modal: ${isVisible}`);
         console.log(`   - Has video: ${!!hasVideo}`);
         console.log(`   - Has poster: ${!!hasPoster}`);
         
         if (isVisible) {
           console.log(`✅ Deferred media ${index + 1} is VISIBLE in modal viewport!`);
           
           if (!hasVideo && hasPoster) {
             console.log(`🎬 Clicking poster to load video for deferred media ${index + 1}`);
             hasPoster.click();
           } else if (hasVideo) {
             console.log(`▶️ Video already loaded for deferred media ${index + 1}`);
             // Play the video if it's visible and loaded
             playVideo(deferredMedia);
           }
         } else {
           console.log(`❌ Deferred media ${index + 1} is NOT visible in modal viewport`);
           // Pause the video if it's not visible and loaded
           if (hasVideo) {
             pauseVideo(deferredMedia);
           }
         }
       });
     }
     
     // Function to play video
     function playVideo(deferredMedia) {
       const video = deferredMedia.querySelector('video');
       const youtubeVideo = deferredMedia.querySelector('.js-youtube');
       const vimeoVideo = deferredMedia.querySelector('.js-vimeo');
       
       if (video && video.paused) {
         console.log('▶️ Playing HTML5 video');
         video.muted = true;
         video.play().catch(e => console.log('Video play failed:', e));
       } else if (youtubeVideo) {
         console.log('▶️ Playing YouTube video');
         youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
       } else if (vimeoVideo) {
         console.log('▶️ Playing Vimeo video');
         vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*');
       }
     }
     
     // Function to pause video
     function pauseVideo(deferredMedia) {
       const video = deferredMedia.querySelector('video');
       const youtubeVideo = deferredMedia.querySelector('.js-youtube');
       const vimeoVideo = deferredMedia.querySelector('.js-vimeo');
       
       if (video && !video.paused) {
         console.log('⏸️ Pausing HTML5 video');
         video.pause();
       } else if (youtubeVideo) {
         console.log('⏸️ Pausing YouTube video');
         youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
       } else if (vimeoVideo) {
         console.log('⏸️ Pausing Vimeo video');
         vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*');
       }
     }
    
    // Set up scroll listener for modal content
    function setupModalScrollListener() {
      const modal = document.querySelector('.product-media-modal');
      if (!modal) return;
      
      const modalContent = modal.querySelector('.product-media-modal__content');
      if (!modalContent) return;
      
      // Debounced scroll handler
      let scrollTimeout;
      modalContent.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          checkVideoVisibility();
        }, 150);
      });
      
      console.log('📜 Modal scroll listener set up');
    }
    
         // Set up window scroll event listener to check video visibility
     let scrollTimeout;
     window.addEventListener('scroll', () => {
       clearTimeout(scrollTimeout);
       scrollTimeout = setTimeout(() => {
         if (isModalOpen()) {
           checkVideoVisibility();
         }
       }, 150); // Debounced scroll handler
     });
    
         // Set up scroll listener when modal is created
     const modalObserver = new MutationObserver((mutations) => {
       mutations.forEach((mutation) => {
         if (mutation.type === 'childList') {
           mutation.addedNodes.forEach((node) => {
             if (node.nodeType === 1 && node.classList && node.classList.contains('product-media-modal')) {
               console.log('🎭 Modal detected, setting up scroll listener...');
               setTimeout(setupModalScrollListener, 100);
             }
           });
         }
       });
     });
     
     modalObserver.observe(document.body, {
       childList: true,
       subtree: true
     });
     
     // Set up observer to watch for video elements being added to deferred media
     const videoObserver = new MutationObserver((mutations) => {
       mutations.forEach((mutation) => {
         if (mutation.type === 'childList') {
           mutation.addedNodes.forEach((node) => {
             if (node.nodeType === 1) {
               // Check if a video element was added
               if (node.tagName === 'VIDEO' || node.classList?.contains('js-youtube') || node.classList?.contains('js-vimeo')) {
                 const deferredMedia = node.closest('deferred-media');
                 if (deferredMedia) {
                   console.log('🎬 Video element detected! Checking visibility...');
                   
                   // Give the video a moment to initialize, then check visibility
                   setTimeout(() => {
                     if (isModalOpen()) {
                       const isVisible = isElementVisibleInModal(deferredMedia);
                       if (isVisible) {
                         console.log('🎯 Video is visible, playing it...');
                         playVideo(deferredMedia);
                       } else {
                         console.log('🎯 Video is not visible, pausing it...');
                         pauseVideo(deferredMedia);
                       }
                     }
                   }, 500);
                 }
               }
             }
           });
         }
       });
     });
     
     // Observe all deferred media elements for video additions
     deferredMediaElements.forEach(deferredMedia => {
       videoObserver.observe(deferredMedia, {
         childList: true,
         subtree: true
       });
     });
     

    
    // Also try to set up scroll listener immediately in case modal already exists
    setupModalScrollListener();
    
    console.log('✅ Global video visibility monitoring initialized');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"])`).forEach((element) => {
        element.classList.remove('active');
      })
      const activeMedia = this.querySelector(`[data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) 
        activeMedia.loadContent();
      
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Select the node that will be observed for mutations
              const targetNode = this.querySelectorAll(".grid__item .card-information__wrapper");

              // Options for the observer (which mutations to observe)
              const config = { childList: true };

              targetNode.forEach(node => {
                // Callback function to execute when mutations are observed
                const callback = (mutationList, observer) => {
                  for (const mutation of mutationList) {
                    if (mutation.type === "childList") {
                      const items = document.querySelectorAll(".product-card");

                      items.forEach((item) => {
                        const whataStarContainer = item.querySelector('.whata-star-container');
                        if(whataStarContainer){
                          let reviewText = whataStarContainer.querySelector('div > span:last-child').textContent;
                          if (reviewText.includes('(')) {
                            let reviewNumberIndex = reviewText.indexOf('(');
                            let trimmedText = reviewText.substring(0, reviewNumberIndex - 1);
                            whataStarContainer.querySelector('div > span:last-child').textContent = trimmedText;
                          }
                        }
                      });

                      document.querySelectorAll('.whata-star-container').forEach(item => {
                        item.classList.add('visible');
                      });
                      observer.disconnect();
                    }
                  }
                };

                // Create an observer instance linked to the callback function
                const observer = new MutationObserver(callback);

                // Start observing the target node for configured mutations
                observer.observe(node, config);
              });
            }
            
            
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
